import { CancelCivilUnionFormVM } from 'mutation/view-models/cancel-civil-union';
import { transformCivilStatus } from 'shell/utils/consult-person/request-transformer/marital-status/civil-status';
import { RequestCancelCivilUnion } from 'shell/models/cancel-civil-union';
import { transformVoidCivilUnionAnpr05 } from 'shell/utils/consult-person/request-transformer/marital-status/void-civil-union-anpr-05';
import { transformCivilUnionAnpr05 } from 'shell/utils/consult-person/request-transformer/marital-status/civil-union-anpr-05';

export const transformerRequestCancelCivilUnionData = (
  values: CancelCivilUnionFormVM
): RequestCancelCivilUnion => {
  const statoCivile = transformCivilStatus(values.civilStatus);

  const civilUnion = transformCivilUnionAnpr05({
    ...(values.civilUnion || {}),
    eventDate: values.civilUnion?.dateEvent,
    italian: values.civilUnion?.italian
      ? {
          location: values.civilUnion.italian.locality,
          municipality: values.civilUnion.italian.municipality,
          province: values.civilUnion.italian.municipality?.province,
        }
      : undefined,
    foreign: values.civilUnion?.foreign
      ? {
          municipality: values.civilUnion.foreign.municipalityForeign,
          province: values.civilUnion.foreign.provinceForeign,
          state: values.civilUnion.foreign.foreignState,
        }
      : undefined,
    digital: values.civilUnion?.digital || undefined,
  });

  return {
    statoCivile,
    datiControllo: {
      tipoMutazione: ['19', '01'],
    },
    generalitaPerRicerca: {
      ...(values.person?.generality || {}),
    },
    generalitaDaModificare: {
      generalita: {
        ...(values.person?.generality || {}),
      },
    },
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || '',
    },
    unioneCivile: {
      ...civilUnion,
      unitoCivilmente: civilUnion?.unitoCivilmente || null,
      scioglimentoUnione: values.cancelCivilUnion
        ? {
            ...transformVoidCivilUnionAnpr05({
              ...(values.cancelCivilUnion || {}),
              type: values.cancelCivilUnion?.reasonCancel,
            }),
            sentenza: null,
          }
        : undefined,
    },
  };
};
